<template>
  <div>
    <base-select-search
      :is-loading="loading"
      :data="productPromos.data"
      :shadow="shadow"
      :inset="inset"
      :input-label="label"
      :fullwidth="fullwidth"
      placeholder="Cari Promo"
      v-model="selected"
      v-on:infinite-scroll="handleInfiniteScroll"
      v-on:search="handleSearch"
      v-on:change="handleChange"
    />
  </div>
</template>

<script>
import BaseSelectSearch from '@/components/base/BaseSelectSearch.vue';
import { requestMixin } from '@/mixins/request/request';

export default {
  name: 'ProductPromoSelectSearch',
  mixins: [requestMixin],
  components: { BaseSelectSearch },
  props: {
    value: null,
    limit: {
      type: Number,
      default: 10,
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
    shadow: {
      type: Boolean,
      default: true,
    },
    inset: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Promo',
    },
    fullwidth: Boolean,
    requestParams: Object
  },
  emits: ['input', 'change'],
  data: function () {
    return {
      search: null,
      size: null,
      loading: false,
      productPromos: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  computed: {
    selected: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    init: function () {
      this.size = this.limit;
      
      this.loadProductPromos();
    },
    loadProductPromos: async function () {
      this.loading = true;

      const [res, error] = await this.request('/api/v1/product-promos', {
        params: {
          'page[size]': this.size,
          'filter[search]': this.search,
          ...this.requestParams
        },
      });

      if (!error) {
        this.productPromos = res;
      }

      this.loading = false;
    },
    handleInfiniteScroll: function () {
      if (this.productPromos.meta.page.hasMore) {
        this.size += this.limit;

        this.loadProductPromos();
      }
    },
    handleSearch: function (search) {
      this.size = this.limit;
      this.search = search;

      this.loadProductPromos();
    },
    handleChange: function () {
      this.$emit('change');
    },
  },
  created: function () {
    this.init();
  },
};
</script>
